import React from 'react';

/**
 * Widget Sticky Zone Props
 */

export type WidgetStickyZoneProps = {
  children: React.ReactNode;
};

/**
 * Widget Sticky Zone Component
 */

export default function WidgetStickyZone({ children }: WidgetStickyZoneProps) {
  return (
    <div className="mdS:h-[56rem] flex h-full flex-col flex-wrap gap-4 md:h-full md:flex-nowrap md:gap-8">
      {React.Children.map(
        children,
        (child) =>
          !!child && (
            <div className="mdS:w-[calc(50%-0.5rem)] h-fit w-full flex-1 flex-grow-0 md:h-full md:w-full md:flex-auto first:md:hidden">
              {child}
            </div>
          ),
      )}
    </div>
  );
}
